__turbopack_context__.v({
  "className": "playfair_display_f8e11a8b-module__3Yjgiq__className",
});
